export const styles = {
  wave: (delay: number) => ({
    '&::after': {
      animationDelay: `${delay}s`,
      animationDuration: '1.2s',
    },
  }),
};
